import styles from './index.less';
import animate from '../../styles/animate.less';
import { addClass, removeClass, hideNode } from '../../utils/utils';
import ThreeModel from 'yjtec-three-model';

export default class Model3d {
  constructor(props) {
    this.wrapper = props.wrapper;
    this.props = props || '';
    this.visible = true;
    this._init();
  }

  _init() {
    this._render();
  }

  _render() {
    const props = this.props;
    const modelId = 'model-' + props.model_id;

    this.dom = document.createElement('div');
    this.dom.classList.add(styles['info-modal']);
    this.dom.innerHTML = `<div class="model3d ${styles['info-wrapper']} ${animate['animate__animated']} ${animate['animate__bounceInLight']}">
      <div>
        <div class="${styles['content']}">
          <div id="${modelId}" class="${styles['model3d-c']}"></div>

          <div class="${styles['details']}">
            <div class="${styles['title']}" style="${!props.title && 'display:none'}">
              ${props.title}
            </div>
            <div class="${styles['desc']}" style="${!props.describe && 'display:none'}">
              ${props.describe}
            </div>
            <a class="${styles['jump-btn']}" style="${!props.jumpUrlTitle && 'display:none'}" href="${props.jumpUrl ? props.jumpUrl : '#'}">
              ${props.jumpUrlTitle}
            </a>
          </div>
        </div>
        <div class="${styles['close-btn']}">X</div>
      </div>
    </div>`;
    
    this.dom.querySelector(`.${styles['close-btn']}`).addEventListener('click', () => {
      this.hide();
    });
    this.wrapper.appendChild(this.dom);

    let modelDom = document.getElementById(modelId);

    window.addEventListener('resize', function(){
      if (document.body.clientWidth <= 480) {
        modelDom.style.cssText = "width:" + document.body.clientWidth * 0.8 + "px;height:" + document.body.clientWidth * 0.8 + "px" ;
      }else{
        modelDom.style.cssText = "width:400px;height:400px";
      }
    });

    let obj = {};
    const path = props.path.url + '/';
    const isFbx = props.files.some(item => item.ext.toLowerCase() == 'fbx');
    const isMtl = props.files.some(item => item.ext.toLowerCase() == 'mtl');
    obj.basePath = path;
    props.files.map(item=>{
      const extLowerCase = item.ext.toLowerCase();
      if (extLowerCase == 'obj' || extLowerCase == 'fbx') {
        obj.objSrc = item.name;
      }
      if (!isFbx) {
        if (isMtl) {
          if (extLowerCase == 'mtl') {
            obj.mtlSrc = item.name;
          }
        }else{
          if (extLowerCase == 'jpg' || extLowerCase == 'png') {
            obj.mapsSrc = item.name;
          }
        }
      }
    });

    const model3d = new ThreeModel({
      el: modelDom,
      autoRotate:false,
      // actionBtns:[],
      ...obj,
      on: {
        init: () => {},
        loadComplete: () => {},
      },
    });
  }

  show() {
    const model3dDiv = this.dom.querySelector('.model3d');
    this.dom.style.display = 'flex';
    removeClass(model3dDiv, animate['animate__bounceOut']);
    addClass(model3dDiv, animate['animate__bounceInLight']);
    this.visible = true;
  }

  hide() {
    const model3dDiv = this.dom.querySelector('.model3d');
    removeClass(model3dDiv, animate['animate__bounceInLight']);
    addClass(model3dDiv, animate['animate__bounceOut']);
    window.removeEventListener('resize', function(){});
    hideNode(this.dom);
    this.visible = false;
  }
}
